import { useSyncExternalStore } from 'react';

export interface DeployState {
  status: 'PENDING' | 'PROCESSING' | 'STOPPING' | null;
  title: string;
  subtitle: string;
}

let state: DeployState = { status: null, title: '', subtitle: '' };
const listeners = new Set<() => void>();

function notify() {
  listeners.forEach((l) => l());
}

export function setDeployStatus(
  status: DeployState['status'],
  title = '',
  subtitle = '',
) {
  state = { status, title, subtitle };
  notify();
}

export function useDeployStatus(): DeployState {
  return useSyncExternalStore(
    (cb) => { listeners.add(cb); return () => listeners.delete(cb); },
    () => state,
  );
}
